<ng-container *ngIf="register$ | async"></ng-container>

<app-public-layout-wrapper>
  <div leftside class="container-side-left">
    <div class="title-side-left">{{ 'register.salut' | translate }}</div>
    <div class="body-side-left">
      <p>{{ 'register.description' | translate }}</p>
      <p>{{ 'register.description2' | translate }}</p>
    </div>
    <div class="footer-side-left">
      <div class="title-bold">
        {{ 'register.already-have-an-account' | translate }}
      </div>
      <app-button
        class="ind-btn-wrapper-100"
        className="ind-btn ind-btn--secondary"
        type="submit"
        label="buttons.labels.signin"
        [routerLink]="loginPath"></app-button>
    </div>
  </div>
  <ng-container rightside>
    <app-header-public />
    <app-register-form *ngIf="!verifyingEmail.isShown" (submitForm)="onSubmit($event)" />

    <app-verifying-email *ngIf="verifyingEmail.isShown" [email]="verifyingEmail.email" />
  </ng-container>
</app-public-layout-wrapper>
